import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const StorageTab = ({ tripData, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    hasFridge: tripData?.hasFridge ?? false,
    hasFreezer: tripData?.hasFreezer ?? false,
    hasIceCooler: tripData?.hasIceCooler ?? false
  });
  const [saving, setSaving] = useState(false);

  const handleChange = (name, checked) => {
    setFormData(prev => ({ ...prev, [name]: checked }));
  };

  const handleSave = async () => {
    setSaving(true);
    const result = await onUpdate(formData);
    setSaving(false);
    
    if (result?.success) {
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      hasFridge: tripData?.hasFridge ?? false,
      hasFreezer: tripData?.hasFreezer ?? false,
      hasIceCooler: tripData?.hasIceCooler ?? false
    });
    setIsEditing(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold" style={{ color: 'var(--color-text-primary)' }}>
          Storage Configuration
        </h2>
        {!isEditing && (
          <Button
            onClick={() => setIsEditing(true)}
            variant="outline"
            size="sm"
          >
            <Icon name="Edit" size={16} />
            <span className="ml-2">Edit</span>
          </Button>
        )}
      </div>

      <p className="text-sm text-muted-foreground">
        Configure your available cold storage options. This affects meal suggestions and ingredient storage recommendations.
      </p>

      <div className="space-y-4">
        <div className="flex items-start space-x-3 p-4 rounded-lg" style={{ backgroundColor: 'var(--color-background)' }}>
          <Checkbox
            id="hasFridge"
            checked={formData?.hasFridge}
            onCheckedChange={(checked) => handleChange('hasFridge', checked)}
            disabled={!isEditing}
          />
          <div className="flex-1">
            <label htmlFor="hasFridge" className="text-sm font-medium cursor-pointer" style={{ color: 'var(--color-text-primary)' }}>
              Refrigerator
            </label>
            <p className="text-xs text-muted-foreground mt-1">
              Standard refrigeration for fresh ingredients and leftovers
            </p>
          </div>
        </div>

        <div className="flex items-start space-x-3 p-4 rounded-lg" style={{ backgroundColor: 'var(--color-background)' }}>
          <Checkbox
            id="hasFreezer"
            checked={formData?.hasFreezer}
            onCheckedChange={(checked) => handleChange('hasFreezer', checked)}
            disabled={!isEditing}
          />
          <div className="flex-1">
            <label htmlFor="hasFreezer" className="text-sm font-medium cursor-pointer" style={{ color: 'var(--color-text-primary)' }}>
              Freezer
            </label>
            <p className="text-xs text-muted-foreground mt-1">
              Frozen storage for long-term ingredient preservation
            </p>
          </div>
        </div>

        <div className="flex items-start space-x-3 p-4 rounded-lg" style={{ backgroundColor: 'var(--color-background)' }}>
          <Checkbox
            id="hasIceCooler"
            checked={formData?.hasIceCooler}
            onCheckedChange={(checked) => handleChange('hasIceCooler', checked)}
            disabled={!isEditing}
          />
          <div className="flex-1">
            <label htmlFor="hasIceCooler" className="text-sm font-medium cursor-pointer" style={{ color: 'var(--color-text-primary)' }}>
              Ice Cooler
            </label>
            <p className="text-xs text-muted-foreground mt-1">
              Portable cooling for beverages and short-term storage
            </p>
          </div>
        </div>
      </div>

      {isEditing && (
        <div className="flex gap-3 pt-4">
          <Button onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save Changes'}
          </Button>
          <Button onClick={handleCancel} variant="outline" disabled={saving}>
            Cancel
          </Button>
        </div>
      )}
    </div>
  );
};

export default StorageTab;